var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:full-screen-two"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.7C5 5.3134 5.3134 5 5.7 5H9.9C10.2866 5 10.6 5.3134 10.6 5.7C10.6 6.0866 10.2866 6.4 9.9 6.4H6.4V9.9C6.4 10.2866 6.0866 10.6 5.7 10.6C5.3134 10.6 5 10.2866 5 9.9V5.7ZM14.1 6.4C13.7134 6.4 13.4 6.0866 13.4 5.7C13.4 5.3134 13.7134 5 14.1 5H18.3C18.6866 5 19 5.3134 19 5.7V9.9C19 10.2866 18.6866 10.6 18.3 10.6C17.9134 10.6 17.6 10.2866 17.6 9.9V7.38995L14.245 10.745C13.9716 11.0183 13.5284 11.0183 13.255 10.745C12.9817 10.4716 12.9817 10.0284 13.255 9.75503L16.61 6.4H14.1ZM10.745 13.255C11.0183 13.5284 11.0183 13.9716 10.745 14.245L7.38995 17.6H9.9C10.2866 17.6 10.6 17.9134 10.6 18.3C10.6 18.6866 10.2866 19 9.9 19H5.7C5.3134 19 5 18.6866 5 18.3V14.1C5 13.7134 5.3134 13.4 5.7 13.4C6.0866 13.4 6.4 13.7134 6.4 14.1V16.61L9.75503 13.255C10.0284 12.9817 10.4716 12.9817 10.745 13.255ZM19 14.1V18.3C19 18.6866 18.6866 19 18.3 19H14.1C13.7134 19 13.4 18.6866 13.4 18.3C13.4 17.9134 13.7134 17.6 14.1 17.6H17.6V14.1C17.6 13.7134 17.9134 13.4 18.3 13.4C18.6866 13.4 19 13.7134 19 14.1Z",
    fill: "white",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/Resize.c94a7076df7babc217c9079140dccde8.svg";
export { ForwardRef as ReactComponent };